const BEIJING_TIME_ZONE = 'Asia/Shanghai';

const normalizeConferenceAgendaTimeValue = (value?: number | string) => {
  if (value === undefined || value === null || value === '') return undefined;
  if (typeof value === 'number') {
    return value > 100000000000 ? value : value * 1000;
  }

  const trimmed = value.trim();
  if (/^\d+$/.test(trimmed)) {
    const timestamp = Number(trimmed);
    return timestamp > 100000000000 ? timestamp : timestamp * 1000;
  }

  // 议程配置中的无时区日期统一解释为北京时间，避免海外浏览器按本地时区偏移。
  const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(trimmed);
  const parsed = Date.parse(
    hasTimeZone
      ? trimmed
      : `${trimmed.replace(/-/g, '/')}${
          trimmed.includes(':') ? '' : ' 00:00:00'
        }+08:00`
  );
  return Number.isNaN(parsed) ? undefined : parsed;
};

const beijingClockFormatter = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: BEIJING_TIME_ZONE,
});

export const formatConferenceAgendaClockRange = (
  start?: number | string,
  end?: number | string
) => {
  const startMs = normalizeConferenceAgendaTimeValue(start);
  const endMs = normalizeConferenceAgendaTimeValue(end);
  if (!startMs && !endMs) return '';

  const format = (timestamp: number) =>
    beijingClockFormatter.format(new Date(timestamp));

  if (startMs && endMs) {
    return `${format(startMs)} - ${format(endMs)}`;
  }
  return format((startMs || endMs) as number);
};
